import { Either, left, right } from "fp-ts/lib/Either";
import StablishmentEntity from "../../../../domain/entities/StablishmentEntity";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import StablishmentDto from "../../../dto/StablishmentDto";

const UpdateStablishmentApiImpl = async (stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>> => {
    try {
        const relativeUrl = `/stablishments/${stablishment.id}`;
        const body = StablishmentDto.toJson(stablishment);
        const response = await di.get<HostApi>(HostApiName).put(relativeUrl, body, {
            contentType: "application/json",
        });

        const parsed: StablishmentEntity = StablishmentDto.fromJSON(response.stablishment);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default UpdateStablishmentApiImpl;